// extracted by mini-css-extract-plugin
module.exports = {"text":"HeroSectionText_text__Olrzw","centered":"HeroSectionText_centered__GCH4H"};